<div class="content">
  <form [formGroup]="form">
    <glxy-form-field>
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.ADD_CONTACT_TO_KIXIE_POWERLIST.CONTACT_ID' | translate }}
      </glxy-label>
      <input matInput formControlName="contact_id" required [disabled]="!isEditMode" />
    </glxy-form-field>

    <glxy-form-field>
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.ADD_CONTACT_TO_KIXIE_POWERLIST.CONNECTION_ID' | translate }}
      </glxy-label>
      <input matInput formControlName="connection_id" required [disabled]="!isEditMode" />
    </glxy-form-field>

    <glxy-form-field>
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.ADD_CONTACT_TO_KIXIE_POWERLIST.POWERLIST_ID' | translate }}
      </glxy-label>
      <input matInput formControlName="powerlist_id" required [disabled]="!isEditMode" />
    </glxy-form-field>
  </form>
</div>
